<template>
    <div id="MessageList" class="text-left menu-component">
        <div class="row">
            <div class="col-12">
                <h4>Mensagens</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-center mt-5" v-if="messageList.length == 0">
                <p>Nenhuma mensagem encontrada</p>
            </div>
            <div class="col-12 mb-3" v-for="(message, index) in filterMessages" :key="index" v-else>
                <messageCard :messageData="message"></messageCard>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import messageCard from '@/components/molecules/MessageCard';
export default {
    name: 'MessageList',
    data(){
        return{
            messageList:[],
        }
    },
    props:{
        siteId: {
            type: Number,
            required: true
        }
    },
    methods:{
        getMessages
    },
    created(){
        this.getMessages();
    },
    components:{
        messageCard
    },
    computed:{
        filterMessages(){
            return this.messageList
        }
    }
}
function getMessages() {
    let token = localStorage.getItem('jwt');
    axios({
        method: "get",
        url: process.env.ROOT_API + "api/site/" + this.siteId + "/submit",
        data: '',
        headers: {
        Authorization: "Bearer " + token
        // 'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
    .then(response => {
        if(response.data.status == 1){
            this.messageList = response.data.contents;
        }else{
            console.log('Erro');
        }
    })
    .catch(response => {
        console.log('erro');
    });
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/organisms/MessageList.vue